import { render, staticRenderFns } from "./ListsPage.vue?vue&type=template&id=3aaa39ac"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports